import React from "react";

function SettingsButton({ onClick }) {
  return (
    <button
      type="button"
      aria-label="Open settings"
      onClick={onClick}
      className="fixed bottom-20 right-8 z-50 flex h-8 w-8 items-center justify-center rounded-full border border-cyan-400/30 bg-[#001833]/70 text-cyan-300 transition-all duration-300 hover:border-cyan-400/80 hover:text-cyan-100"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        className="h-4 w-4"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.325 4.317a1.724 1.724 0 013.35 0 1.724 1.724 0 002.573 1.066 1.724 1.724 0 012.906 1.675 1.724 1.724 0 00.888 2.573 1.724 1.724 0 010 3.35 1.724 1.724 0 00-.888 2.573 1.724 1.724 0 01-2.906 1.675 1.724 1.724 0 00-2.573 1.066 1.724 1.724 0 01-3.35 0 1.724 1.724 0 00-2.573-1.066 1.724 1.724 0 01-2.906-1.675 1.724 1.724 0 00-.888-2.573 1.724 1.724 0 010-3.35 1.724 1.724 0 00.888-2.573 1.724 1.724 0 012.906-1.675 1.724 1.724 0 002.573-1.066z"
        />
        <circle cx="12" cy="12" r="3" />
      </svg>
    </button>
  );
}

export default SettingsButton;
